import React from "react";
import { Text, Img, Button, Heading } from "components";

export default function ModelFeatures({
  ...props
}) {
  return (
    <div {...props}
    className={`${props.className} flex flex-col items-center sm:w-full gap-5 px-[22px] py-6 sm:px-5 border-black-900_01 border border-solid bg-gray-300`}
   >
      <div className="flex flex-col items-center self-stretch">
        <Heading size="headingmd" as="h2" className="font-semibold text-indigo-700">
          Model Features
        </Heading>
      </div>

      <div className="flex flex-col gap-2.5 self-stretch">

        <div className="flex items-center gap-2.5">
          <Img src="images/img_material_symbols_check.svg" alt="Feature Check Icon" className="h-[24px] w-[24px]" />
          <Text as="p" className="self-center text-[18px] font-normal leading-[120%] text-black-900">
             Meticulously-designed dashboard that clearly summarizes portfolio risk while allowing investment-decision making
          </Text>
        </div>

        <div className="h-px bg-black-900_01" />

        <div className="flex items-center gap-2.5">
          <Img src="images/img_material_symbols_check.svg" alt="Feature Check Icon" className="h-[24px] w-[24px]" />
          <Text as="p" className="self-center text-[18px] font-normal leading-[120%] text-black-900">
          Ability to assess risk for individual portfolios as well as combinations thereof
          </Text>
        </div>

        <div className="h-px bg-black-900_01" />
        <div className="flex items-center gap-2.5">
          <Img src="images/img_material_symbols_check.svg" alt="Feature Check Icon" className="h-[24px] w-[24px]" />
          <Text as="p" className="self-center text-[18px] font-normal leading-[120%] text-black-900">
          Dynamic system capable of running alternate portfolios and user-defined what-if scenarios on the fly
          </Text>
        </div>

        <div className="h-px bg-black-900_01" />
        <div className="flex items-center gap-2.5">
          <Img src="images/img_material_symbols_check.svg" alt="Feature Check Icon" className="h-[24px] w-[24px]" />
          <Text as="p" className="self-center text-[18px] font-normal leading-[120%] text-black-900">
          Comprehensive coverage of liquid and illiquid investments, as well as structured products
          </Text>
        </div>

        <div className="h-px bg-black-900_01" />
        <div className="flex items-center gap-2.5">
          <Img src="images/img_material_symbols_check.svg" alt="Feature Check Icon" className="h-[24px] w-[24px]" />
          <Text as="p" className="self-center text-[18px] font-normal leading-[120%] text-black-900">
          Full transparency of risk drivers and concentrations via the ability to slice and dice risk across multiple dimensions, including asset type, industry, region, sector, key risk sensitivities (duration, convexity, and Greeks), risk factors, and individual positions
          </Text>
        </div>
        
        <div className="h-px bg-black-900_01" />
        <div className="flex items-center gap-2.5">
          <Img src="images/img_material_symbols_check.svg" alt="Feature Check Icon" className="h-[24px] w-[24px]" />
          <Text as="p" className="self-center text-[18px] font-normal leading-[120%] text-black-900">
          User-defined modeling choices, including risk metric, return frequency, simulation approach, investment horizon, and confidence level
          </Text>
        </div>
        
        <div className="h-px bg-black-900_01" />
        <div className="flex items-center gap-2.5">
          <Img src="images/img_material_symbols_check.svg" alt="Feature Check Icon" className="h-[24px] w-[24px]" />
          <Text as="p" className="self-center text-[18px] font-normal leading-[120%] text-black-900">
          Choice between model-suggested and user input of relevant benchmarks and expected returns
          </Text>
        </div>
        <div className="h-px bg-black-900_01" />
        <div className="flex items-center gap-2.5">
          <Img src="images/img_material_symbols_check.svg" alt="Feature Check Icon" className="h-[24px] w-[24px]" />
          <Text as="p" className="self-center text-[18px] font-normal leading-[120%] text-black-900">
          Return-risk attribution across multiple dimensions
          </Text>
        </div>
       

      </div>
    </div>
  );
}
